import React, { useState, useEffect } from "react";
import Header from "../Components/ManageUsers/Header";
import ManageUserOverview from "../Components/ManageUsers/ManageUserOverview";
import { getManageUser } from "../actions/ManageUserAction";

const ManageUsers = () => {
  // const [data, setData] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalCount, setTotalCount] = useState(0);
  // const [searchTerm, setSearchTerm] = useState("");
  // const [itemsPerPage, setItemsPerPage] = useState(10);

  // const fetchData = async () => {
  //   const response = await getManageUser(searchTerm, currentPage, itemsPerPage);
  //   console.log("response", response);
  //   if (response.success) {
  //     setData(response.data);
  //     setCurrentPage(response.currentPage);
  //     setTotalCount(response.totalCount);
  //     setTotalPages(response.totalPages);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, [currentPage, itemsPerPage, searchTerm]);
  return (
    <div className="mt-4">
      <Header />
      <ManageUserOverview
      // data={data}
      // currentPage={currentPage}
      // totalPages={totalPages}
      // totalCount={totalCount}
      // setCurrentPage={setCurrentPage}
      // setSearchTerm={setSearchTerm}
      // setItemsPerPage={setItemsPerPage}
      // itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default ManageUsers;
